import { DREVSaisie } from './drevsaisie.model';
import { Produit } from '../../habilitation/models/produit.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Campagne } from './campagne.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationRevendication {
    static jsonMap = {
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        mention: { key: 'mention', optional: true, default: '' },
        campagne: { key: 'idCampagne', converter: new (DataIdConverterFactory.build(Campagne, 'campagnes'))(), optional: true },
        surface: { key: 'surface' },
        volumeNetRevendiqueEncours: { key: 'volumeNetRevendiqueEncours' },
        // VCI déclaré l'année précédente != stock VCI réel
        vciPasse: { key: 'vciPasse' },
        vinsEnCours: { key: 'vinsEnCours' },
        reserveVsiLiberee: { key: 'reserveVsiLiberee' },
        vciEnCours: { key: 'vciEnCours' },
        vsi: { key: 'vsi' },
        drevSaisie: { key: 'drevSaisie', converter: new (ClassConverterFactory.build(DREVSaisie))(), optional: true }
    };

    codeProduit: string;
    mention: string;
    campagne: Campagne;
    surface: number;
    volumeNetRevendiqueEncours: number;
    /**
     * VCI déclaré l'année précédente != stock VCI réel
     */
    vciPasse: number;
    vinsEnCours: number;
    reserveVsiLiberee: number;
    vciEnCours: number;
    vsi: number;
    drevSaisie: DREVSaisie = new DREVSaisie();

    produit: Produit = new Produit();

    /**
     * Retourne le stock VCI de l'année N-1 d'une déclaration
     * @returns Un Number
     */
    public getStockVciLastYear(): number {
        return this.drevSaisie.totalVciUtilise ? this.drevSaisie.totalVciUtilise : this.vciPasse;
    }

    /**
     * Retourne le stock de vin de l'année courant d'une déclaration
     * @returns Un Number
     */
    public getStockWineCurrentYear(): number {
        return this.vinsEnCours - this.drevSaisie.vciRemplacement - this.drevSaisie.vciSubstitution;
    }

    /**
     * Retourne le stock VCI courant d'une déclaration
     * @returns Un Number
     */
    public getStockVciCurrentYear(): number {
        return this.vciEnCours + this.drevSaisie.vciRemplacement;
    }

    /**
     * Affecte une saisie d'un VCI à une DREV et calcule le volume net
     * revendiqué pour l'année en cours
     * @param saisie La saisie d'un VCI à affecter
     */
    public setSaisieVci(saisie: DREVSaisie): void {
        this.drevSaisie = saisie;
        this.calculateVolumeNetRevendique();
    }

    /** Calcule le volume net revendiqué pour l'année en cours */
    private calculateVolumeNetRevendique(): void {
        this.volumeNetRevendiqueEncours = this.drevSaisie.totalVciUtilise + this.getStockWineCurrentYear() + this.reserveVsiLiberee;
    }
}
